import { render, staticRenderFns } from "./SocialWallCommentList.vue?vue&type=template&id=310f3d26&scoped=true"
import script from "./SocialWallCommentList.vue?vue&type=script&lang=js"
export * from "./SocialWallCommentList.vue?vue&type=script&lang=js"
import style0 from "./SocialWallCommentList.vue?vue&type=style&index=0&id=310f3d26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310f3d26",
  null
  
)

export default component.exports